import { InvoiceStatus, InvoiceType } from '../../../domain/types';
import { PaginatedResult, PaginationParams, serializePagination } from '../../pagination';
import { API_INVOICES_SERP_PATH, getClient } from '../api';
import { SerpInvoice } from '../dtos';
import { serializeParams } from '../utils/serializer';

export interface SerpInvoiceProviderFilters {
  q?: string,
  status?: InvoiceStatus | InvoiceStatus[],
  type?: InvoiceType | InvoiceType[],
  paymentDateGt?: Date,
  paymentDateLt?: Date,
  agentEmail?: string | string[],
}

export async function getSerpInvoices(
  filters: SerpInvoiceProviderFilters = {},
  pagination: PaginationParams = { size: 20 },
): Promise<PaginatedResult<SerpInvoice>> {
  const client = await getClient();

  const { data } = await client.get(API_INVOICES_SERP_PATH, {
    params: {
      ...serializeParams(filters),
      ...serializePagination(pagination),
    },
  });

  return data;
}
